import React from 'react';
import { Path } from 'react-native-svg';

import { IconBase, IconProps } from './IconBase';
import { SVG_PATH_TOAST_FEATURE_PIN_WITH_PUSHPIN } from './svgPaths';

export const IconToastFeature: React.FunctionComponent<IconProps> = (props) => (
  <IconBase viewBox="0 0 12 12" {...props}>
    <Path d={SVG_PATH_TOAST_FEATURE_PIN_WITH_PUSHPIN} fill="currentColor" />
  </IconBase>
);
